/**
 * Brabantmemes — Scroll animaties & hover effecten
 * Gebruikt Intersection Observer voor performante scroll-reveals
 */

(function () {
  'use strict';

  /* ── SCROLL REVEAL ─────────────────────────────────────────── */

  function initScrollReveal() {
    // Voeg .bm-animate toe aan alle sectie-elementen
    var targets = [
      '.section-header',
      '.guarantee-item',
      '.hero-container',
      '.featured-image-section',
      '.featured-row',
      '.featured-columns',
      '[data-section-type="quotes-section"] .box',
      '[data-section-type="newsletter-section"] .box',
      '[data-section-type*="instagram"] .bm-instagram-grid > *',
    ];

    targets.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el, i) {
        if (!el.classList.contains('bm-animate')) {
          el.classList.add('bm-animate');
          // Staggered delay voor rij-elementen (max 6)
          var delay = Math.min(i % 6 + 1, 6);
          el.setAttribute('data-delay', delay);
        }
      });
    });

    // Garantie-items: links naar rechts
    document.querySelectorAll('.guarantee-item').forEach(function (el, i) {
      if (i % 2 === 0) {
        el.classList.add('bm-animate--left');
      } else {
        el.classList.add('bm-animate--right');
      }
    });

    // Intersection Observer
    var observerOptions = {
      root: null,
      rootMargin: '0px 0px -80px 0px',
      threshold: 0.1
    };

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          // Niet meer observeren na eerste keer
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    document.querySelectorAll('.bm-animate').forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ── PARALLAX HERO ─────────────────────────────────────────── */

  function initParallax() {
    var allHeros = document.querySelectorAll('.hero-parallax');
    var heros = Array.prototype.filter.call(allHeros, function(el) {
      return !el.closest('#section-1568145568761');
    });
    if (!heros.length) return;

    var ticking = false;

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          var scrollY = window.scrollY || window.pageYOffset;
          heros.forEach(function (hero) {
            var rect = hero.getBoundingClientRect();
            var inView = rect.bottom > 0 && rect.top < window.innerHeight;
            if (inView) {
              var offset = scrollY * 0.25;
              hero.style.backgroundPositionY = 'calc(50% + ' + offset + 'px)';
            }
          });
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /* ── RETRO HOVER TILT ──────────────────────────────────────── */

  function initCardTilt() {
    document.querySelectorAll('.guarantee-item').forEach(function (card) {
      card.addEventListener('mousemove', function (e) {
        var rect = card.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var y = e.clientY - rect.top;
        var cx = rect.width / 2;
        var cy = rect.height / 2;
        var rotX = ((y - cy) / cy) * -4;
        var rotY = ((x - cx) / cx) * 4;
        card.style.transform = 'translateY(-3px) rotateX(' + rotX + 'deg) rotateY(' + rotY + 'deg)';
        card.style.transition = 'transform 0.1s ease';
      });

      card.addEventListener('mouseleave', function () {
        card.style.transform = '';
        card.style.transition = 'transform 0.3s ease, box-shadow 0.3s ease';
      });
    });
  }

  /* ── RETRO SECTIE-DIVIDERS ─────────────────────────────────── */

  function injectDividers() {
    // Voeg decoratieve streep in tussen hoofd-secties
    var sections = document.querySelectorAll(
      '.guarantee-section, [data-section-type="featured-products-section"], [data-section-type*="instagram"]'
    );

    sections.forEach(function (section) {
      var divider = document.createElement('div');
      divider.className = 'bm-divider';
      section.parentNode.insertBefore(divider, section);
    });
  }

  /* ── SMOOTH SCROLL ─────────────────────────────────────────── */

  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
      anchor.addEventListener('click', function (e) {
        var target = document.querySelector(this.getAttribute('href'));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  /* ── LIVE WINKELWAGEN PRIJSUPDATE (via Shopify Cart API) ───── */
  /*
   * Na elke hoeveelheidswijziging wordt de cart gesynct met Shopify
   * via /cart/update.js, waarna de pagina opnieuw geladen wordt.
   * Zo berekent Shopify zelf alle kortingen correct (2+1 gratis,
   * staffelkorting, etc.) en rendert de server alle prijzen opnieuw.
   * Dit voorkomt conflicten met ymq-b2b en andere cart-apps.
   */

  function initCartPriceUpdate() {
    var cartForm = document.querySelector('form.cart');
    if (!cartForm) return;

    var debounceTimer = null;

    // Verzamel alle huidige hoeveelheden
    function collectUpdates() {
      var updates = {};
      cartForm.querySelectorAll('.cart__product-qty[data-id]').forEach(function (input) {
        updates[input.getAttribute('data-id')] = parseInt(input.value, 10) || 0;
      });
      return updates;
    }

    // Toon laad-indicator zodat de gebruiker weet dat de klik geregistreerd is
    function showLoading() {
      var overlay = document.getElementById('bm-cart-loading');
      if (!overlay) {
        overlay = document.createElement('div');
        overlay.id = 'bm-cart-loading';
        overlay.style.cssText = [
          'position:fixed', 'inset:0', 'z-index:99999',
          'background:rgba(61,26,0,0.18)',
          'display:flex', 'align-items:center', 'justify-content:center',
          'backdrop-filter:blur(2px)'
        ].join(';');
        overlay.innerHTML =
          '<div style="background:#F5ECD7;border:2px solid #C41E3A;border-radius:8px;' +
          'padding:18px 32px;font-family:Caveat,cursive;font-size:1.3rem;' +
          'color:#3D1A00;font-weight:700;box-shadow:4px 4px 0 #C41E3A;">' +
          '\u231B Even bijwerken...' +
          '</div>';
        document.body.appendChild(overlay);
      }
      overlay.style.display = 'flex';
    }

    // Stuur update naar Shopify en herlaad de pagina
    function syncAndReload() {
      showLoading();
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ updates: collectUpdates() })
      })
        .finally(function () {
          window.location.reload();
        });
    }

    // Debounce: wacht 500ms na de laatste klik voor reload
    function scheduleSync() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(syncAndReload, 500);
    }

    // +/- knoppen (theme-JS werkt de input bij, dus 80ms wachten)
    cartForm.addEventListener('click', function (e) {
      if (e.target.closest('.qty-adjust')) setTimeout(scheduleSync, 80);
    });

    // Directe invoer in het aantal-veld
    cartForm.addEventListener('change', function (e) {
      if (e.target.classList.contains('cart__product-qty')) scheduleSync();
    });
  }

  /* ── KORTING PRIJSCORRECTIE (na ymq-b2b app) ──────────────── */

  function fixDiscountedPrices() {
    var items = window.bmCartLineItems;
    if (!items || !items.length) return;

    function euro(cents) {
      if (cents === 0) return '€0,00';
      return '€' + (cents / 100).toFixed(2).replace('.', ',');
    }

    function correct() {
      items.forEach(function (item) {
        if (item.o === item.f) return;
        var attr = item.i + '-' + item.k;
        var span = document.querySelector('[ymq-b2b-item-final-line-price][ymq-b2b-item-key="' + attr + '"]');
        if (span) span.textContent = euro(item.f);
      });
    }

    correct();
    setTimeout(correct, 400);
    setTimeout(correct, 1000);
  }

  /* ── INIT ───────────────────────────────────────────────────── */

  function init() {
    if ('IntersectionObserver' in window) {
      initScrollReveal();
    } else {
      // Fallback: direct zichtbaar maken voor oudere browsers
      document.querySelectorAll('.bm-animate, .grid-product').forEach(function (el) {
        el.classList.add('is-visible');
      });
    }

    initParallax();
    initCardTilt();
    injectDividers();
    initSmoothScroll();
    initCartPriceUpdate();
    fixDiscountedPrices();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
